import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFontStyle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFontStyle"><Path fillRule="evenodd" clipRule="evenodd" d="M19 20H20.5V21H14.75V20H16.3711L14.418 14H7.95605L6.00293 20H7.5V21H3.5V20H4.9502L10.4854 3H13.4658L19 20ZM8.28125 13H14.0918L11.1865 4.07617L8.28125 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFontStyle;
